import {
  SAVE_CERTIFICATE,
  GET_CERTIFICATE,
  CERTIFICATES_ERROR,
} from '../constants/actionTypes';
import * as api from '../api/index.js';

export const saveUserCertificate =
  certificateData => async dispatch => {
    try {
      const result = await api.saveCertificate(certificateData);

      dispatch({
        type: SAVE_CERTIFICATE,
        payload: {
          Certificate: result.data.certificateContent,
        },
      });
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data;
      } else {
        return 'Something went wrong. Please try again!';
      }
    }
  };

export const getuserCertificate = certificateId => {
  return async dispatch => {
    try {
      const result = await api.getCertificate(certificateId);

      if (!result?.data?.data) {
        throw new Error(
          result?.response?.data?.message ||
            'Failed to fetch the certificate',
        );
      }
      dispatch({
        type: GET_CERTIFICATE,
        payload: {
          Certificate: result.data.data,
        },
      });
    } catch (error) {
      dispatch({
        type: CERTIFICATES_ERROR,
        payload: {
          error: {
            action: GET_CERTIFICATE,
            message:
              error.response?.data?.message ||
              'Failed to fetch the certificate',
          },
        },
      });
    }
  };
};
